var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelopAlert = function SvgEnvelopAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 95,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCE3FF",
    d: "M15 24.71a4.8 4.8 0 0 1 4.8-4.8h86.4a4.8 4.8 0 0 1 4.8 4.8v57.6a4.8 4.8 0 0 1-4.8 4.8H19.8a4.8 4.8 0 0 1-4.8-4.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3391FF",
    d: "m27 87.109 18.597-38.4 16.08 10.523a4.8 4.8 0 0 0 5.283-.018L82.782 48.71l18.619 38.4z",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3391FF",
    d: "M15.091 23.774q-.09.456-.091.935v4.695l47.436 30.153a3.6 3.6 0 0 0 3.917-.035L111 29.997V24.71a5 5 0 0 0-.021-.452L64.354 55.089z",
    opacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#888EA0",
    fillRule: "evenodd",
    d: "M110.573 40.963H84.928c-3.788 0-6.156-4.083-4.261-7.349l7.88-13.586h14.026a8 8 0 0 1 8 8z",
    clipRule: "evenodd",
    opacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBC02D",
    d: "M99.252 7.744c1.349-2.325 4.721-2.325 6.07 0l13.787 23.773c1.349 2.326-.337 5.233-3.035 5.233H88.5c-2.698 0-4.384-2.907-3.035-5.233z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#18223D",
    strokeWidth: 1.708,
    d: "M103.035 30.245a.854.854 0 1 1-1.709 0 .854.854 0 0 1 1.709 0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#18223D",
    strokeLinecap: "round",
    strokeWidth: 3.417,
    d: "M102.083 25.247v-8.435"
  })));
};
export default SvgEnvelopAlert;